import React from 'react';

import { CardExpiryElement } from '@stripe/react-stripe-js';
import type { StripeCardExpiryElementChangeEvent } from '@stripe/stripe-js';

import { stripeElementDomId } from '#src/app/shared/utils/payments';

type Props = {
	onChange?: (event: StripeCardExpiryElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const CardExpiryElementWrapper: React.FC<Props> = ({ onChange, onFocus, onBlur }) => {
	return (
		<CardExpiryElement
			id={stripeElementDomId('cardExpiry')}
			options={{ style: { base: { fontSize: '16px' } } }}
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
		/>
	);
};
